<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row v-if="!users && !loadingData" align="center">
      <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
        <EmptyPage
          :page-title="$t('emptySurveysInActivityTitle')"
          :page-text="$t('emptySurveysInActivityText')"
          page-image="image5"
        />
      </v-col>
    </v-row>
    <v-row v-else align="center" class="mx-auto mt-5">
      <v-col cols="11" class="mx-auto px-0">
        <v-card
          v-for="(user, index) in numberedUsers"
          :key="index"
          rounded="xxl"
          class="my-2 solo"
          @click="showUserSurveyDetail(user.id)"
          data-testid="show-attempt-info"
        >
          <v-hover>
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover ? 8 : 2}`"
            >
              <v-col cols="12" class="px-6">
                <div class="text-body-2 grey--text justify-left">
                  {{ $t("name") }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.submitted_by }}
                </div>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import { getAttemptsInSurvey } from "../../api/activityApi";
import EmptyPage from "../../components/EmptyPage";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import AlertMessages from "../../components/AlertMessages";

export default {
  components: {
    EmptyPage,
    AlertMessages,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      users: [],
      surveyId: this.$route.params.surveyId,
      activityId: this.$route.params.id,
      spaceId: window.$cookies.get("space_id"),
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loadingData: false
    };
  },
  computed: {
    numberedUsers() {
      const nameCount = {};
      const appendCount = (name) => {
        if (nameCount[name]) {
          nameCount[name]++;
        } else {
          nameCount[name] = 1;
        }
        return `${name} ${nameCount[name]}`;
      };

      return this.users.map((user) => {
        if (user.attributes.submitted_by != null) {
          //
        } else {
          user.attributes.submitted_by = appendCount("Anonymous");
        }

        return user;
      });
    },
  },
  async created() {
    this.loadingData = true;
    await this.fetchAttemptsInActivity();
    this.loadingData = false;
  },
  methods: {
    showSummarySurveyDetail(id) {
      this.$router.push({
        path: "/activity/" + this.activityId + "/survey/" + id + "/summary",
      });
    },
    async fetchAttemptsInActivity() {
      try {
        const response = await getAttemptsInSurvey(this.surveyId);
        if (response.status) {
          if (response.status == 200) {
            this.users = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async showUserSurveyDetail(attempt) {
      this.$router.push({
        path:
          "/activity/" +
          this.activityId +
          "/survey/" +
          this.surveyId +
          "/individuals/" +
          attempt,
      });
    },
  },
};
</script>
